const AuditLogSelectors = {
  getStatus: state => state.auditLogs.status,
  getLogs: state => state.auditLogs.logs,
  getTopicActionOptions: state => state.auditLogs.topicActionOptions,
  getUserOptions: state => state.auditLogs.userOptions,
  getCount: state => state.auditLogs.count,
};

export default AuditLogSelectors;
